import React, { useEffect } from 'react';

// import { useState } from 'react';

// material-ui
import {
    Avatar,
    Box,
    IconButton,
    Stack,
    Tooltip,
    useTheme
} from '@mui/material';

// project imports
// import AddTaskModal from './AddTaskModal';
import AddTimer from './AddTimer';
import Timer from 'jsx/views/timesheet/employee/Timer';
import { getWeekDates, filterDataByDate } from 'utils/dates';
import useAPI from 'hooks/useAPI';
import TimesheetService from 'services/TimesheetService';
import { getCurrentTask, getLeaveEntry, getTimesheet, getWeekEntry, editTimeEntry } from 'store/slices/timesheet';

// assets
// import AlarmRoundedIcon from '@mui/icons-material/AlarmRounded';
// import StopIcon from '@mui/icons-material/Stop';
// import TimerIcon from '@mui/icons-material/Timer';
import StopIcon from '@mui/icons-material/Stop';

// third-party
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'store';

// ==============================|| PunchClock ||============================== //

const PunchClock = () => {

    const theme = useTheme();
    const activeTimerTask = useSelector((state) => state.timesheet.currentTask);
    const dispatch = useDispatch();
    const company_uuid = useSelector((state) => state.user.profile.companyUUID);
    const employee_uuid = useSelector((state) => state.user.profile.employeeUUID);
    // const [openAddTask, setOpenAddTask] = useState(false);
    const checkTimerTask = Object.keys(activeTimerTask).length === 0;
    const currentTask = useSelector((state) => state.timesheet.currentTask);

    // const openAddModal = () => {
    //     setOpenAddTask(true);
    // };

    const onStopTimer = () => {
        stopTimerAPI.execute(company_uuid, employee_uuid, currentTask.uuid);
    };

    const categorizeEntries = (data) => {
        return data.reduce(
            (acc, task) => {
                if (task.type === 'leave-entry') {
                    acc.leaveEntries.push(task);
                } else {
                    acc.timeEntries.push(task);
                }
                return acc;
            },
            { leaveEntries: [], timeEntries: [] }
        );
    };

    const createWeekViewData = (data) => {
        return data.map((entry) => {
            return {
                uuid: entry.uuid,
                durationInSeconds: entry.durationInSeconds,
                type: entry.type,
                project: entry.project,
                leaveSession: entry.leaveSession,
                startTime: entry.startTime
            };
        });
    };

    const userTimesheetSuccessHandler = (response) => {
        dispatch(getTimesheet(response.data.items));
        dispatch(getLeaveEntry(categorizeEntries(response.data.items).leaveEntries));
        dispatch(getWeekEntry(createWeekViewData(response.data.items)));
        const filteredData = filterDataByDate(response.data.items, format(new Date(), 'yyyy-MM-dd'));
        const currentTask1 = filteredData.find(
            (task) => task.punchEnabled === 1 && (task.punchStatus === 'start' || task.punchStatus === 'pause')
        );
        if (currentTask1) {
            dispatch(getCurrentTask(currentTask1));
        }
    };

    function handleSuccess(response) {
        dispatch(editTimeEntry(response.data));
        if (response.data.punchStatus === 'stop') {
            dispatch(getCurrentTask({}));
        } else {
            dispatch(getCurrentTask(response.data));
        }
    }

    /* ---------- API's ---------- */
    const userTimesheetAPI = useAPI(TimesheetService.getTimesheet, userTimesheetSuccessHandler);
    const stopTimerAPI = useAPI(TimesheetService.punchStop, handleSuccess, true);

    useEffect(() => {
        const weekDates = getWeekDates(new Date());
        userTimesheetAPI.execute(company_uuid, employee_uuid, weekDates[0], weekDates[weekDates.length - 1]);
    }, []);

    return (
        <>
            <Box
                sx={{
                    // width: 228,
                    marginRight: '10px',
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.primary : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.dark,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.light
                        },
                        ...(!checkTimerTask ? { width: '100px' } : {})
                    }}
                    color="inherit"
                >
                    {
                        checkTimerTask ? (
                            <Tooltip title="Start Timer">
                                <AddTimer />
                            </Tooltip>

                        ) : (
                            <Tooltip title="Punch Out">
                                <Stack direction="row" onClick={onStopTimer}>
                                    <IconButton>
                                        <StopIcon fontSize="small" color="error" />
                                    </IconButton>
                                    <Timer paddingTopValue={1} paddingRightValue={1} />
                                </Stack>
                            </Tooltip>
                        )
                    }
                </Avatar>
            </Box>
        </>
    );
};

export default PunchClock;
